import { memo } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { areEqual } from 'react-window';
import styled from 'styled-components';

import { Grid } from '@mui/material';
import { Driver } from '../../../../../../domain/driver/Driver';
import { Stop } from '../../../../../../domain/stop/Stop';
import { PlanOverviewStopChip } from '../plan-overview-stop-chip/PlanOverviewStopChip';

export const VirtualizedRowContainer = styled.div`
  display: flex;
  user-select: none;
`;

type VirtualizedStopRowProps = {
  data: {
    stops: Stop[];
    drivers: Driver[];
    selectedStops: string[];
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, stop: Stop) => void;
  };
  index: number;
  style: any;
};

export const VirtualizedStopRow = memo(({ data, index, style }: VirtualizedStopRowProps) => {
  const { stops, drivers, selectedStops, onClick } = data;
  const stop = stops[index];

  const stopDriver = drivers.find((driver) => driver.id === stop.driver_id);

  return (
    <Draggable isDragDisabled={stopDriver?.is_locked} draggableId={stop.id} index={index} key={stop.id}>
      {(provided, snapshot) => (
        <VirtualizedRowContainer
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{ ...style, ...provided.draggableProps.style }}
        >
          <Grid style={{ padding: `2px 5px`, height: `100%`, width: `100%` }}>
            <PlanOverviewStopChip
              stop={stop}
              selectedStops={selectedStops}
              isDragging={snapshot.isDragging}
              onClick={onClick}
            />
          </Grid>
        </VirtualizedRowContainer>
      )}
    </Draggable>
  );
}, areEqual);
